import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Prop, Component, Vue } from 'vue-property-decorator';
import * as styles from "./index.module.css";
/** 编辑/新建一个StyleSheet emit出编辑后的结果 和新建所需的配置项 */
let StyleSheetMultiSelect = class StyleSheetMultiSelect extends Vue {
  renderSelectOptions() {
    const h = this.$createElement;
    return this.allStyleSheet.map(styleSheet => h("a-select-option", {
      "key": styleSheet.id
    }, [styleSheet.name]));
  }
  get selected() {
    return this.selectedSheet.map(styleSheet => styleSheet.id);
  }
  render() {
    const h = arguments[0];
    return h("a-select", _mergeJSXProps([{
      "attrs": {
        "mode": "tags",
        "placeholder": "选择模板",
        "value": this.selected
      },
      "class": styles.templateSelector
    }, {
      "on": this.$listeners
    }]), [this.renderSelectOptions()]);
  }
};
__decorate([Prop({
  type: Array,
  required: true
})], StyleSheetMultiSelect.prototype, "allStyleSheet", void 0);
__decorate([Prop({
  type: Array,
  required: true
})], StyleSheetMultiSelect.prototype, "selectedSheet", void 0);
StyleSheetMultiSelect = __decorate([Component({
  name: 'StyleSheetMultiSelect'
})], StyleSheetMultiSelect);
export { StyleSheetMultiSelect };
//# sourceMappingURL=StyleSheetMultiSelect.js.map
